/**
 * The one read rankingDecision.ts cannot do from the rows it is handed: which
 * Decision a priority list's governance event names. The bridge (migration
 * 568; 1007 for ratifying and publishing) writes `decision_id` back onto the
 * list's event — `priority_list_approved` (the Catchball approval),
 * `priority_set_ratified` and `priority_set_published` — and the event, not
 * the decision row, carries `priority_set_id`.
 */
import { getTypedSupabaseClient } from '../typedSupabaseClient';

/**
 * The governance events that write a Decision for a priority list, in both
 * spellings the app writes (ratify_priority_list and the app's publish write
 * upper case; publish_session_results writes lower case).
 */
export const LIST_DECISION_EVENT_TYPES: readonly string[] = [
  'priority_list_approved',
  'priority_set_ratified', 'PRIORITY_SET_RATIFIED',
  'priority_set_published', 'PRIORITY_SET_PUBLISHED',
];

/**
 * Priority list id → the id of the Decision its newest act wrote: a list that
 * was ratified and then published reads its publication's Decision.
 */
export async function fetchListApprovalDecisionIds(prioritySetIds: readonly string[]): Promise<Map<string, string>> {
  const ids = Array.from(new Set(prioritySetIds.filter(Boolean)));
  const out = new Map<string, string>();
  if (ids.length === 0) return out;
  const { data, error } = await getTypedSupabaseClient()
    .from('governance_events')
    .select('priority_set_id, decision_id, occurred_at')
    .in('priority_set_id', ids)
    .in('event_type', [...LIST_DECISION_EVENT_TYPES])
    .not('decision_id', 'is', null)
    .order('occurred_at', { ascending: false });
  if (error || !data) return out;
  for (const row of data) {
    if (row.priority_set_id && row.decision_id && !out.has(row.priority_set_id)) out.set(row.priority_set_id, row.decision_id);
  }
  return out;
}
